<template>
  <div class="maintenance-error">
    <img src="@/assets/images/illustration/maintenance/maintenance.svg" />
    <h1>{{ $t('app.maintenance.title') }}</h1>
    <p v-safe-html="$t('app.maintenance.text')">
    </p>
  </div>
</template>